/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

const SvgIconChatbotBot = props => {
  return (
    <svg viewBox="0 0 35 35" {...props} role="img" aria-hidden="true" focusable="false">
      <defs>
        <filter
          id="icon-bot-chatbot_svg__b"
          width="126%"
          height="126%"
          x="-13%"
          y="-6.5%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={1} />
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
        </filter>
        <circle id="icon-bot-chatbot_svg__a" cx={15.4} cy={15.4} r={15.4} />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(2)">
        <mask id="icon-bot-chatbot_svg__c" fill="#fff">
          <use xlinkHref="#icon-bot-chatbot_svg__a" />
        </mask>
        <use fill="#000" filter="url(#icon-bot-chatbot_svg__b)" xlinkHref="#icon-bot-chatbot_svg__a" />
        <use fill="#FFF" xlinkHref="#icon-bot-chatbot_svg__a" />
        <g mask="url(#icon-bot-chatbot_svg__c)">
          <g transform="translate(16.038 -1.424)">
            <path
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={0.659}
              d="M4.123 2.682C3.552 3.088 2.498 4.281.962 6.26l.532 2.25"
            />
            <ellipse cx={4.223} cy={2.629} fill="#000" rx={2.655} ry={2.629} />
            <ellipse cx={4.223} cy={2.629} fill="#EF6461" rx={1.328} ry={1.314} />
          </g>
          <path
            fill="#EF6461"
            d="M15.815 7.119h2.253c7.077 0 12.815 5.738 12.815 12.815v8.864a3.952 3.952 0 01-3.952 3.951H6.951A3.952 3.952 0 013 28.798v-8.864C3 12.857 8.737 7.119 15.815 7.119z"
          />
          <path
            fill="#943E3C"
            d="M17.143 7.119c-7.078 0-12.815 5.738-12.815 12.815v8.864a3.951 3.951 0 003.951 3.951H6.951A3.952 3.952 0 013 28.798v-8.864C3 12.857 8.737 7.119 15.815 7.119z"
          />
          <g transform="translate(11.63 11.72)">
            <ellipse cx={6.639} cy={10.515} fill="#FFF" stroke="#FFF" strokeWidth={0.659} rx={6.309} ry={6.242} />
            <path
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.976}
              d="M11.616 1.588a11.539 11.539 0 00-5.27-1.26C4.36.329 2.496.824.88 1.692"
            />
            <ellipse cx={6.639} cy={10.515} fill="#000" rx={3.319} ry={3.286} />
            <ellipse cx={8.63} cy={8.543} fill="#FFF" rx={1.328} ry={1.314} />
          </g>
          <g>
            <path fill="#FFF" stroke="#000" strokeWidth={0.5} d="M5.91 13.725l9.231-5.117 1.943 3.503-9.232 5.118z" />
            <text
              fill="#000"
              fontFamily="PublicoHeadline-Bold, Publico Headline"
              fontSize={3.226}
              fontWeight="bold"
              transform="rotate(-29 29.538 -2.383)"
            >
              <tspan x={3.089} y={3.961}>
                WIP
              </tspan>
            </text>
            <path
              fill="#FFE5A0"
              fillOpacity={0.577}
              d="M5.536 14.858l.669-.85 2.123 1.646-.669.85zM15.317 9.07l1.004-.407 1.002 2.489-1.005.407z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgIconChatbotBot;
